const timers = document.querySelectorAll('.countdown-timer')

timers.forEach(timer => {
  const stopDatetime = timer.dataset.finish
  const countDownDate = new Date(stopDatetime).getTime()

  const x = setInterval(function() {
    const now = new Date().getTime()
    const difference = countDownDate - now
    const isoDate = new Date(difference).toISOString()
    const secondsRemaining = Math.floor(difference / 1000)

    timer.querySelector('.countdown-days').innerHTML = Math.floor(secondsRemaining / (60 * 60 * 24))
    timer.querySelector('.countdown-hours').innerHTML = isoDate.slice(11, 13)
    timer.querySelector('.countdown-minutes').innerHTML = isoDate.slice(14, 16)
    timer.querySelector('.countdown-seconds').innerHTML = isoDate.slice(17, 19)

    if (secondsRemaining < 0) {
      clearInterval(x)
      timer.innerHTML = '-- -- -- --'
    }
  }, 1000)
})
